import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { Gift } from '../models/gift';
import { GiftDetailBox } from './giftDetailBox';

interface GiftOrderDataProps {
  gift: Gift;
}

export const GiftDetailOrderData = (props: GiftOrderDataProps) => {
  const { gift } = props;
  const { t } = useTranslation(['gift']);

  const DisplayOrderDetail = ({ index }) => {
    const giftOrderDetail = gift.order?.orderDatas[index];
    if (giftOrderDetail && giftOrderDetail.label) {
      return <GiftDetailBox label={giftOrderDetail.label}>{giftOrderDetail.value}</GiftDetailBox>;
    }
    return null;
  };

  const DisplayOrderNotificationMessage = () => {
    // if any orderData property named "E-post:" exist, and value is empty, show message for manual sending
    // TODO: new property from API instead
    const missingEmail = gift.order?.orderDatas.some((item) => item.label === 'E-post:' && !item.value);
    if (missingEmail) {
      return (
        <Typography
          sx={{
            fontWeight: 500,
            color: 'red',
            float: 'right',
            display: 'inline',
            ml: 1,
            p: 0.5,
            borderRadius: 1,
            backgroundColor: 'background.default',
          }}
        >
          {t('gift:order.manualInfo')}
        </Typography>
      );
    }

    return null;
  };

  return (
    <ContentSection header={t('gift:order.header')} button={<DisplayOrderNotificationMessage />}>
      <DisplayOrderDetail index={0} />
      <DisplayOrderDetail index={2} />
      <DisplayOrderDetail index={1} />

      <DisplayOrderDetail index={3} />
      <DisplayOrderDetail index={4} />
      <DisplayOrderDetail index={5} />
      <DisplayOrderDetail index={6} />

      <DisplayOrderDetail index={7} />
      <DisplayOrderDetail index={8} />
      <DisplayOrderDetail index={9} />
      <DisplayOrderDetail index={10} />

      <DisplayOrderDetail index={11} />
      <DisplayOrderDetail index={12} />
      <DisplayOrderDetail index={13} />
      <DisplayOrderDetail index={14} />

      <DisplayOrderDetail index={15} />
      <DisplayOrderDetail index={16} />
    </ContentSection>
  );
};
